import { render, staticRenderFns } from "./user-detail-form.vue?vue&type=template&id=2081fb02"
import script from "./user-detail-form.vue?vue&type=script&lang=js"
export * from "./user-detail-form.vue?vue&type=script&lang=js"
import style0 from "./user-detail-form.vue?vue&type=style&index=0&id=2081fb02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports